export default function LoadingSpinner() {
  return (
    <div className="hud-spinner" role="status" aria-label="Loading">
      <div className="hud-spinner-ring">
        <div className="hud-spinner-core" />
      </div>
      <span className="hud-spinner-label">Initializing…</span>
    </div>
  );
}
